import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { transactionHistory, withdrawableTransactions, withdrawalHistory } from '../../Services/DashboardServices';

const columns = [
    { name: 'Account Title', selector: row => row.account_title },
    { name: 'Account Number', selector: row => row.account_number.substring(0, 3) + "****" },
    { name: 'Amount', selector: row => row.amount },
    { name: 'Requested At', selector: row => row.request_at },
    { name: 'Released At', selector: row => row.request_at === null || "" ? row.released_at : row.status },
    { name: 'Admin Notes', selector: row => row.admin_notes === null || row.admin_notes === "" ? "--" : row.admin_notes },
    { name: 'Status', selector: row => row.status },
];

const WithdrawableHistory = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleGetWithdrawableHistory = async () => {
        setLoading(true)
        try {
            const response = await withdrawalHistory();
            setData(response?.result?.history?.original?.data || []);
            setLoading(false)
        } catch (err) {
            setLoading(false)
            console.error("Error fetching transaction history", err);
        }
    };

    useEffect(() => { handleGetWithdrawableHistory(); }, [])


    useEffect(() => {
        const filtered = data.filter(item =>
            Object.values(item).some(value =>
                String(value).toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [filterText, data]);

    return (
        <div>


            <h3 className='fw-bold mb-0'>Withdrawal History</h3>
            <p>
                History of all your's withdrawals request.
            </p>
            <div className='text-end'>
                <input
                    type="text"
                    placeholder="Search..."
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    style={{
                        marginBottom: '10px',
                        padding: '8px',
                        width: '300px',
                        borderRadius: '5px',
                        border: '1px solid #ccc'
                    }}
                />
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div className="spinner-border text-info" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    striped
                />
            )}
        </div>
    );
};

export default WithdrawableHistory;
